interface StatCardProps {
	icon: React.ElementType;
	label: string;
	value: string | number;
	subtitle?: string;
	accent?: string;
}

export function StatCard({
	icon: Icon,
	label,
	value,
	subtitle,
	accent = 'bg-gradient-to-br from-indigo-500 to-indigo-400'
}: StatCardProps) {
	return (
		<div className="group/stat relative rounded-2xl bg-neutral-900/50 p-5 transition-all duration-300 hover:bg-neutral-900/70 hover:shadow-lg hover:shadow-black/20">
			<div className="absolute inset-0 rounded-2xl ring-1 ring-inset ring-white/[0.04] transition-all duration-300 group-hover/stat:ring-white/[0.08]" />
			<div className="relative flex items-start gap-4">
				<div className={`flex size-10 shrink-0 items-center justify-center rounded-xl ${accent}`}>
					<Icon className="size-5 text-white" />
				</div>
				<div className="min-w-0">
					<p className="text-[11px] font-medium uppercase tracking-widest text-neutral-500">{label}</p>
					<p className="mt-1 text-lg font-semibold text-neutral-100">{value}</p>
					{subtitle && <p className="mt-0.5 text-xs text-neutral-500">{subtitle}</p>}
				</div>
			</div>
		</div>
	);
}
